import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import { aliases, mdi } from 'vuetify/iconsets/mdi';
import { VFileUpload } from 'vuetify/labs/VFileUpload';
import { VDateInput } from 'vuetify/labs/VDateInput';

import { darkTheme, lightTheme } from '../theme';

export default createVuetify({
  components: {
    VFileUpload,
    VDateInput,
  },
  theme: {
    defaultTheme: 'darkTheme',
    themes: {
      darkTheme,
      lightTheme,
    },
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
});
